/**
 * @Description 搜索
 */

import V2Tabs from '@/common/components/Data/V2Tabs';

import styles from '../index.module.less';
import { FC, useEffect, useState } from 'react';
import ButtonTabs from '@/common/components/Tabs/ButtonTabs';
import { useMethods } from '@lhb/hook';
import { youthArroundCategory, youthShareArroundCategory } from '@/common/api/youth';
import { useBigdataFn } from '@/common/utils/bigdata';
import { isArray } from '@lhb/func';
import { useSelector } from 'react-redux';
import { demoForCarModelIds } from '@/views/iterate/pages/siteselectionmapb/ts-config';
import { trackingYouthCommunityList, trackingYouthDetailSurroundTab } from '@/common/tracking/youth';

// 带搜索和重置按钮的form
export interface SearchFormProps {
  /** 选中的业态key */
  currentCommercialIndex:string;
  setCurrentCommercialIndex:Function;
  onSearch?: Function; // 确定
  className?: string;
  detail?: any;
  setCurDetail?: any;
  setIsNodata?: any; // 是否无一级tab，或各一级tab下的poi数都为0
  setSurroundingOptions?: any;
  isShare?: boolean;
  shareParams?: any;
}

const Search: FC<SearchFormProps> = ({
  detail,
  onSearch,
  setCurDetail,
  setIsNodata,
  setSurroundingOptions,
  isShare,
  shareParams,
  currentCommercialIndex,
  setCurrentCommercialIndex
}) => {
  const modelConfigId = useSelector((state: any) => state.iterate.modelConfigId); // 存放选址地图页面的当前模型

  const bigdataFn = useBigdataFn(); // 使用埋点 Hook
  const [data, setData] = useState<any>([]);// 原始数据
  const [commercialData, setCommercialData] = useState<any>([]);// 业态
  const [secondCommercialData, setSecondCommercialData] = useState<any>([]);// 二级分类
  const [currentSecondCommercialIndex, setCurrentSecondCommercialIndex] = useState<string>('');// 业态key值
  const [filters, setFilters] = useState<any>({
    aoiTypeCategoryId: '', // 一级分类ID
    secondAoiType: '', // 二级分类Id
    distance: '',
    name: '',
  });

  useEffect(() => {
    if (detail?.id) {
      methods.loadData();
    }
  }, [detail]);

  useEffect(() => {
    if (filters.aoiTypeCategoryId) {
      onSearch?.(filters);
    }
  }, [filters]);

  const methods = useMethods({

    onCommercialChange(activeKey: string) { // 一级分类变化
      setCurDetail?.(null);
      setCurrentCommercialIndex(activeKey);
      methods.handleSecondCommercialData(activeKey);
      // bigdataFn('ebe2a493-a267-484f-98cb-7551dc28ecb5', '详情-周边配套-点击一级TAB', '点击了详情-周边配套-点击一级TAB点击了', { op_block: '开店区域-详情页', op_event: ``, });
      bigdataFn(...trackingYouthDetailSurroundTab);
      const target = commercialData.find((item) => item.key === activeKey);
      if (target?.label?.includes('小区')) {
        bigdataFn(...trackingYouthCommunityList);
      }
    },
    onSecondCommercialChange(activeKey: string) { // 二级分类变化
      setCurDetail?.(null);
      setCurrentSecondCommercialIndex(activeKey);
      let distance = null;
      let secondAoiType = null;
      secondCommercialData.map(item => {
        if (item.key === activeKey) {
          distance = item.distance;
          secondAoiType = item.key;
        }
      });
      setFilters({ ...filters, secondAoiType, distance });
      bigdataFn(...trackingYouthDetailSurroundTab);
    },
    loadData: async () => { // 初始化
      const params: any = {
        lat: detail?.lat,
        lng: detail?.lng,
        cityName: detail?.cityName,
        modelClusterId: detail?.id,
      };
      const targetFetch = isShare ? youthShareArroundCategory : youthArroundCategory;
      if (isShare) {
        params.tenantId = shareParams?.tenantId;
        params.userId = shareParams?.employeeId;
      }
      const res = await targetFetch(params, false);
      const surounds = isArray(res) ? res : [];
      if (demoForCarModelIds.includes(modelConfigId) && surounds.length > 1) { // demo时，将小区放到第二个
        const targetFirst = surounds[1];
        const targetSec = surounds[0];
        surounds[0] = targetFirst;
        surounds[1] = targetSec;
      }
      setData(surounds);
      setIsNodata(!surounds.length);
      setSurroundingOptions?.(surounds);

      const firstData = res?.map((item) => {
        return {
          key: String(item.id),
          label: item.name + (item.num ? ' ' + item.num : ''),
          distance: item.distance,
        };
      }) || [];

      // 设置业态
      setCommercialData(firstData);
      setCurrentCommercialIndex(firstData[0].key);
      methods.handleSecondCommercialData(firstData[0].key);
    },
    // 设置二级分类数据
    handleSecondCommercialData(active: string) {
      const secondCommercialDatas: any = [];
      const target = data.find((item) => String(item.id) === active);
      const targetChildren = target?.children;
      const name = target?.name;
      targetChildren?.forEach((item: any) => {
        secondCommercialDatas.push({
          key: String(item.id),
          label: item.name + (item.num ? ' ' + item.num : ''),
          distance: item.distance,
          name
        });
      });
      const firstData = secondCommercialDatas.length ? secondCommercialDatas[0] : target; // 如果有子级则获取子级，否则获取自己
      setFilters({ ...filters, ...{
        aoiTypeCategoryId: target?.id,
        secondAoiType: firstData?.key || null,
        distance: firstData?.distance || null,
        name: firstData?.name,
      } });
      setCurrentSecondCommercialIndex(firstData?.key); // 设置二级选中的位置
      setSecondCommercialData(secondCommercialDatas); // 设置二级分类数据
    }
  });

  return (
    <div className={styles['search']}>
      <V2Tabs
        activeKey={currentCommercialIndex}
        items={commercialData}
        className={styles['tabs']}
        onChange={methods.onCommercialChange}/>
      {secondCommercialData
        ? <ButtonTabs
          activeKey={currentSecondCommercialIndex}
          items={secondCommercialData}
          className={styles['button-tab']}
          onChange={methods.onSecondCommercialChange}/> : ''}
    </div>

  );
};

export default Search;
